export default __webpack_public_path__ + "static/main-1b7e46c6c0b27694d6af8d271514a19a.png";